import React from "react";

import loader from "src/images/loader.gif";

export default function Loader() {
  return <img src={loader} alt="Loader" style={{ height: 30 }} />;
}
